import React from 'react';
import DrupalHelper from '../../helper/DrupalHelper';
import LegendItem from './LegendItem';
import { AppContext } from '../../context/AppContext';

class Legend extends React.Component {
  constructor(props) {
    super(props);

    this.state = {items: []}
  }

  componentDidMount() {
    let legend = DrupalHelper.getLegend();

    this.setState({items: legend});
  }

  render() {
    return <AppContext.Consumer>
      {({legend, setLegend}) => (
        <div className='legend-wrapper'>
          {this.state.items.map((item) => {
            return <LegendItem
              key={item.value}
              icon={item.icon}
              label={item.label}
              value={item.value}
              selected={item.value === legend}
              onClick={()=>{setLegend(item.value)}}/>
          })}
          <LegendItem key="view_all"
                      label="View All"
                      value="all"
                      selected={"all"===legend}
                      onClick={()=>{setLegend('all')}}/>
        </div>
      )}
    </AppContext.Consumer>;
  }
}

export default Legend